module.exports = __webpack_public_path__ + "fonts/icofont.20e606bb.eot";